<a href="javascript:void(0)" (click)="loadContractDetail()" class="btn-link" porAddFeature featureName="contract-detail-button" [dynamicValue]="cellValue">
    {{ cellValue }}
</a>
